let accordionContainer;
let accordionRow;
let accordionItem;

// let accordionContainer = document.querySelector('[accordion-container]');
// let accordionItem = document.querySelectorAll('[data-accordion]');
// let accordionQ = document.querySelector('[data-accordion-q]');
// let accordionA = document.querySelector('[data-accordion-a]');
// let accordionSpacer = document.querySelector('[data-accordion-spacer]');


const setAccordion = () => { 

  accordionContainer = document.querySelector('[accordion-container]');
  accordionRow = document.querySelectorAll('[data-accordion-row');
  accordionItem = document.querySelectorAll('[data-accordion-q]');

  if (accordionContainer) {
    init();
  }

}

function init() {

  //prepare accordionAnswer containers based on current html structure
  for (var i = 0; i < accordionRow.length; i++) {
    let accordionAnswer = "<ul data-accordion-a-container></ul>"
    accordionRow[i].insertAdjacentHTML('afterend', accordionAnswer);
  }

  for(var i = 0; accordionItem.length > i; i++) {
      var accordionContent = accordionItem[i].querySelector('[data-accordion-a]');

      if(i === 0) {
          setcurrentAccordion(accordionContent, accordionItem[i]);
          addClass(accordionItem[i], 'active');
          showAccordion(accordionContent, accordionItem[i])
      } else {
          setcurrentAccordion(accordionContent, accordionItem[i]);
          // hideAccordion(accordionContent, accordionItem[i]);
      }
      
  }

}

function setcurrentAccordion(accordionContent, accordionItem) {

  let accordionNode = accordionContent.parentNode.parentNode.parentNode.nextElementSibling;
  accordionNode.appendChild(accordionContent);

  accordionItem.addEventListener('click', function() {

      if(hasClass(accordionContent, 'active')) {
          hideAccordion(accordionContent, accordionItem);
      } else {
          hideAllAccordions(accordionContent, accordionItem);
          showAccordion(accordionContent, accordionItem);
      }
  });
}

function hideAllAccordions(accordionContent, accordionItem) {
  accordionContent = document.querySelectorAll('[data-accordion-a]');
  for(var i = 0; accordionContent.length > i; i++) {
      hideAccordion(accordionContent[i], accordionItem);
  }
}

function hideAccordion(accordionContent, accordionItem) {
  accordionItem = document.querySelectorAll('[data-accordion-q]');
  console.log('hideAccordion accordionItem', accordionItem);
  accordionContent.style.height = '0px';
  removeClass(accordionContent, 'active');
  for(var i = 0; accordionItem.length > i; i++) {
    removeClass(accordionItem[i], 'active');
  }
}

function showAccordion(accordionContent, accordionItem) {
  accordionContent.style.height = 100 + '%';
  // console.log('accordionContent', accordionContent);
  // console.log('accordionItem', accordionItem);
  // accordionContent.children[0].style.visilibty = 'visible';
  addClass(accordionContent, 'active');
  addClass(accordionItem, 'active');

}

function hasClass(element, className) {
  if (element.classList) {
      return element.classList.contains(className);
  } else {
      return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
  }
}

function addClass(element, className){
  if(element.className.indexOf(className) == -1) {
      element.className += ' ' + className;
  }          
}

function removeClass(element, name) {
 if (hasClass(element, name)) {
    element.className=element.className.replace(new RegExp('(\\s|^)'+name+'(\\s|$)'),' ').replace(/^\s+|\s+$/g, '');
 }
}

export {setAccordion}

